import http from '../utils/http-common';


const sendQuestion = (data: { name: string; office: string; phone: string; msg: string }) => {
  return http.axiosCreate.post(`/fursys-ques`, { data });
};

export default {
  sendQuestion,
};
